import { render, staticRenderFns } from "./BookingInformation.vue?vue&type=template&id=d50b3622&scoped=true"
import script from "./BookingInformation.vue?vue&type=script&setup=true&lang=ts"
export * from "./BookingInformation.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./BookingInformation.vue?vue&type=style&index=0&id=d50b3622&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d50b3622",
  null
  
)

export default component.exports